import CreateDataFactory from '../../views/CreateDataFactoryProject';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { actions } from '../../../state/project';

const mapStateToProps = (state, ownProps) => ({
    view: ownProps.match.params.view || 'source',
    locale: ownProps.match.params.locale,
    status: state.shift.status,
    name: state.shift.auth.name,
    username: state.shift.auth.username,
    projectList: state.shift.assessment.RepositoryNameList,
    groupId: state.shift.auth.groupId,
    gitlab_id: state.shift.auth.gitlab_id,
    clientname: state.shift.assessment.clientname,
    opportunity_num: state.shift.assessment.opportunity_num,
    reponame: state.shift.assessment.reponame,
    srclang: state.shift.assessment.srclang,
    tgtlang: state.shift.assessment.tgtlang,
    description: state.shift.assessment.description,
    role: state.shift.auth.role,
    flag:state.shift.assessment.flag,
    customersList:state.shift.assessment.customersList,
    customerprojectList:state.shift.assessment.customerprojectList,
    stagingprojectList:state.shift.assessment.stagingprojectList,
    validfree: state.shift.assessment.validfree,
    filesList: state.shift.assessment.filesList,
    customerid: state.shift.auth.customerid,
  });
  
  const mapDispatchToProps = (dispatch, ownProps) => {
    const { locale } = ownProps.match.params;
    return {
      clickBackHandler: value => {
        dispatch(push(`/${locale}/shift`));
      },
  
      clickSubmitHandler: (
        username,
        reponame,
        srclang,
        tgtlang,
        description,
        jobType,
        reponamefordataen,
        customerid,
        projectname,
        fun
      ) => {
        dispatch(
          actions.assessment(
            username,
            reponame,
            srclang,
            tgtlang,
            description,
            jobType,
            reponamefordataen,
            customerid,
            projectname
          )
        ).then((e) => {console.log(e);fun(e)})
       },
  
      getinfobyreponameforaccessment: (value,customerid,jobtype,fun) => {
        console.log(jobtype)
        dispatch(actions.getinfobyreponame(value,customerid,jobtype)).then(
          (e)=> fun(e)
        );
      },
  
      changePrjName: event => {
        dispatch(actions.changedprjName({ value: event.target.value }.value));
      },
  
      gitlabProjects: (type,customerid) =>
        dispatch(actions.customersPrjList(type, customerid)),
  
      getCustomers: ()=>{
        dispatch(actions.customersList());
      },
  
      customersPrjList: (type,cusid)=>{
        dispatch(actions.customersPrjList(type,cusid));
      },
  
      getStagingPrjList: (jobtype,repo,customerid)=>{
        dispatch(actions.stagingPrjList(jobtype,repo,customerid));
      },
  
      checkfree: (username,fun)=>{
        dispatch(actions.checkfree(username)).then(fun());
      },
  
      getfilesList: (groupid,customerid)=>{
        dispatch(actions.filesList(groupid,customerid));
      },
  
      // resetPopError: ()=>{
      //   dispatch(actions.resetPopError())
      // },
  
      resetCustomersPrjList : ()=>{
        dispatch(actions.resetCustomersPrjList());
      },
  
      resetStagingPrjList : ()=>{
        dispatch(actions.resetStagingPrjList());
      },
  
      userRequest: (
        username,
        reponame,
        srclang,
        tgtlang,
        description,
        jobType,
        customerid,
        showMessageTrue)=>{
  
        dispatch(actions.userRequest(
          username,
          reponame,
          srclang,
          tgtlang,
          description,
          jobType,
          customerid
          )).then((e)=> {
            console.log(e)
            showMessageTrue(e)
          }
        );
      }
    };
  
  }

  const CreateDataFactoryProjectComponent = connect(
    mapStateToProps,
    mapDispatchToProps
  )(CreateDataFactory);
  
  export default CreateDataFactoryProjectComponent;


// WEBPACK FOOTER //
// ./src/components/container/CreateDataFactoryProject/index.js